import { Provider } from "react-redux";
import { Routes } from "@/Routes";
import { SentryWrapper } from "@/hooks/sentry";
import { store } from "@/store";
import { Toaster } from "@/components/ui/sonner";
import { InviteModalProvider } from "@/components/InviteModal/InviteModalContext";

export default function App() {
  return (
    <SentryWrapper>
      <Provider store={store}>
        <InviteModalProvider>
          <Routes />
        </InviteModalProvider>
      </Provider>
      <Toaster position="bottom-right" />
    </SentryWrapper>
  );
}
